<div *ngIf="data && data.action === 'delete'; else onCgrpOn" class="popup-main-content-container">
    <h2 class="popup-title"></h2>
    <div class="main-content-container">Confirmez-vous la suppression ?</div>
    <mat-dialog-actions class="buttons-container">
        <div class="button-edit">
            <button class="tv-ns-secondary-large-button-on-light-bg" (click)="onCancelUpdateButtonClick()">Annuler</button>
            <button class="tv-ns-validation-large-button" (click)="okDeleteButtonClick()">Valider</button>
        </div>
    </mat-dialog-actions>
</div>

<ng-template #onCgrpOn>
    <div *ngIf="!isTargetLoaded">
        <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
    </div>
    <div *ngIf="!isShowOption && isTargetLoaded" class="container">
        <div class="title-container">
            <h2 class="mat-title" *ngIf="data && data.action === 'new'">Ajout d'un CGRP Garanti</h2>
            <h2 class="mat-title" *ngIf="data && data.action === 'edit'">Modification</h2>
            <h2 class="mat-title" *ngIf="data && data.action === 'dup'">Duplication</h2>
        </div>
        <div class="tv-ns-custom-horizontal-divider"></div>
        <div class="bloc-container">
            <h4 class="red-title">Général</h4>
            <div class="inputs-container">
                <!-- Target -->

                <!-- Search Item -->
                <div class="tv-rect-input-extensible flex-auto">
                    <mat-form-field>
                        <mat-label>Cible</mat-label>
                        <input
                            class="tv-ns-select-option"
                            type="text"
                            aria-label="Number"
                            matInput
                            [formControl]="targetControl"
                            [matAutocomplete]="auto" />
                        <mat-autocomplete
                            autoActiveFirstOption
                            class="tv-custom-always-visible-scroll-bar"
                            #auto="matAutocomplete"
                            [displayWith]="displayTarget">
                            <mat-option *ngFor="let item of filteredTargetList | async" class="tv-ns-select-option" [value]="item">
                                {{ item.name }} ({{ item.id }})
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <div class="tv-input-error-message" *ngIf="targetControl.touched && targetControl.hasError('required')">
                        <mat-icon class="tv-input-error-icon">error</mat-icon>
                        <span class="tv-input-error-text">Veuillez renseigner une cible</span>
                    </div>
                </div>

                <!-- Date Range -->
                <app-date-range-picker
                    [screenFilterForm]="itemsFilterForm"
                    [paramStartDate]="editStartDate"
                    [paramEndDate]="editEndDate"
                    [isRestrictedToParamDates]="true"
                    [styleType]="'squared'">
                </app-date-range-picker>

                <!-- CA in €  -->
                <div class="tv-rect-input-extensible">
                    <mat-form-field>
                        <mat-label>Montant</mat-label>
                        <input type="number" matInput [formControl]="budgetControl" />
                        <span matSuffix>€</span>
                    </mat-form-field>
                    <div class="tv-input-error-message" *ngIf="budgetControl.touched && budgetControl.hasError('required')">
                        <mat-icon class="tv-input-error-icon">error</mat-icon>
                        <span class="tv-input-error-text">Veuillez saisir une valeur</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="add-category-bloc-container" *ngIf="noCategoryBlockAdded; else test">
            <span>Conditions</span>
            <div>
                <mat-icon class="type-icon" svgIcon="add-circle-fill" (click)="addCategoryBloc('Inclus')"> </mat-icon>
            </div>
        </div>

        <ng-template #test>
            <div class="bloc-container">
                <h4 class="red-title">{{ categoryConditionType }}</h4>
                <div class="inputs-container">
                    <!-- Category -->
                    <div *ngIf="!isCategoryTypeLoading" class="tv-container-select-white-rect-extensible">
                        <mat-form-field>
                            <mat-label>Catégorie de la négo</mat-label>
                            <mat-select panelClass="tv-custom-always-visible-scroll-bar" [formControl]="categoryTypeFormControl">
                                <mat-option *ngFor="let category of categoryTypeList" class="tv-ns-select-option" [value]="category">
                                    {{ category.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <!-- Search -->
                    <!-- Search Item -->
                    <div class="search-item-container">
                        <div class="tv-rect-input-extensible">
                            <mat-form-field>
                                <mat-label>Rechercher</mat-label>
                                <input
                                    class="tv-ns-select-option"
                                    type="text"
                                    aria-label="Number"
                                    matInput
                                    [formControl]="searchFormControl"
                                    [matAutocomplete]="auto" />
                                <mat-autocomplete
                                    autoActiveFirstOption
                                    class="tv-custom-always-visible-scroll-bar"
                                    #auto="matAutocomplete"
                                    [displayWith]="displayItem">
                                    <mat-option *ngFor="let item of filteredItemList | async" class="tv-ns-select-option" [value]="item">
                                        {{ item.name }} ({{ item.id }})
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    </div>
                    <button *ngIf="categoryType" (click)="listAllOptions()" class="tv-round-icon-button-icon-medium-light-blue">
                        <mat-icon>list</mat-icon>
                    </button>
                </div>
                <div class="container-chips" *ngIf="selectedOptions.size > 0">
                    <mat-chip-set class="tv-chip-dark-square">
                        <mat-chip *ngFor="let item of selectedOptions" (removed)="removeCondition(item)">
                            {{ item.category.name }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                    </mat-chip-set>
                </div>
            </div>
        </ng-template>

        <div class="button-edit">
            <button class="tv-ns-secondary-large-button-on-light-bg" (click)="onCancelUpdateButtonClick()">Annuler</button>
            <button class="tv-ns-validation-large-button" (click)="onValidationButtonClick()">Valider</button>
            <div *ngIf="saving" class="main-validation-container" id="onLoading">
                <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
            </div>
        </div>
    </div>

    <div *ngIf="isShowOption" class="container-options">
        <div class="">
            <mat-checkbox class="tv-blueish-grey-checkbox" (change)="onSelectAllChange($event)">Sélectionner Tout</mat-checkbox>
        </div>

        <div class="tv-ns-custom-horizontal-divider"></div>

        <div class="search-container">
            <div
                class="tv-round-input-extensible-no-label full-width"
                [ngClass]="{ 'fade-in-right': panelOpened, 'fade-out-left': !panelOpened }">
                <mat-form-field>
                    <mat-icon matPrefix class="small-icon">search</mat-icon>
                    <input matInput [formControl]="optionFormControl" name="search" />
                </mat-form-field>
            </div>
        </div>

        <div *ngIf="isItemLoading" class="spinner-container">
            <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
        </div>

        <div class="checkbox-list" *ngIf="!isItemLoading">
            <mat-checkbox
                class="tv-blueish-grey-checkbox"
                *ngFor="let item of filteredOptions | async"
                [checked]="isOptionSelected(item)"
                (change)="onOptionChange($event, item)">
                {{ item.name }} ({{ item.id }})
            </mat-checkbox>
        </div>

        <div class="button-edit" *ngIf="!isItemLoading">
            <button class="tv-ns-secondary-large-button-on-light-bg" (click)="goBack()">Annuler</button>
            <button class="tv-ns-validation-large-button" (click)="saveOptions()">Valider</button>
        </div>
    </div>
</ng-template>
